import { useCallback } from "react";
import { faSun, faMoon, faDesktop } from "@fortawesome/free-solid-svg-icons";

export const useThemeHelpers = (theme, setTheme) => {
  const handleThemeChange = useCallback(
    (event) => {
      const newTheme = event.target.value;
      setTheme(newTheme);
    },
    [setTheme]
  );

  const getThemeIcon = useCallback((themeValue) => {
    switch (themeValue) {
      case "light":
        return faSun;
      case "dark":
        return faMoon;
      case "auto":
        return faDesktop;
      default:
        return faSun;
    }
  }, []);

  const getThemeLabel = useCallback((themeValue) => {
    switch (themeValue) {
      case "light":
        return "Light";
      case "dark":
        return "Dark";
      case "auto":
        return "Auto (System)";
      default:
        return "Light";
    }
  }, []);

  return {
    handleThemeChange,
    getThemeIcon,
    getThemeLabel,
  };
};
